import type { RenderMenuItemProps } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import CreatePollAction from './create-poll-action.js'
import InviteAction from './invite-action.js'
import PollDetailsAction from './poll-details-action.js'

const Actions: FC<RenderMenuItemProps> = props => (
  <>
    <CreatePollAction {...props} />
    <PollDetailsAction {...props} />
    <InviteAction {...props} />
  </>
)

export default Actions
